const successMsgs = {
  changePassword: "تم تغيير كلمة المرور بنجاح",
  deletedSuccessfully: "تم الحذف",
  addedSuccessfully: "تم الاضافة بنجاح",
  eventDeletedSuccessfully: "تم حذف الفعالية بنجاح",
  eventCanceledSuccessfully: "تم إلغاء الفعالية بنجاح",
  approveRequest: "تم قبول الطلب بنجاح",
  updatedSuccessfully: "تم التحديث بنجاح",
  acceptRequest: "تم قبول الطلب بنجاح",
  rejectRequest: "تم رفض الطلب",
  forgetPassword: "تم ارسال كلمة مرور جديدة لبريدك الإلكتروني",
  blockedSuccessfully: "تم حظر المستخدم بنجاح",
  unBlockedSuccessfully: "تم الغاء حظر المستخدم بنجاح",
  applicantsInvitedSuccessfully: "تم دعوة المتقدمين بنجاح",
  companyActivated: "تم تفعيل الشركة بنجاح",
  companyDeactivated: "تم إلغاء تفعيل الشركة بنجاح",
  companyUpdatedSuccessfully: "تم تحديث ملف الشركة بنجاح",
  companyEditRequestApproved: "تمت الموافقة على طلب تحديث الملف بنجاح",
  companyEditRequestRejected: "تم رفض طلب تحديث الملف",
  eventPublishedSuccessfully: "تم نشر الفعالية بنجاح",
  eventUpdatedSuccessfully: "تم تحديث الفعالية بنجاح",
};

export default successMsgs;
